import * as faceapi from 'face-api.js'

const SSD_MOBILENETV1 = 'ssd_mobilenetv1'
const TINY_FACE_DETECTOR = 'tiny_face_detector'

const selectedFaceDetector = SSD_MOBILENETV1

// ssd_mobilenetv1 options
const minConfidence = 0.5

// tiny_face_detector options
const inputSize = 512
const scoreThreshold = 0.4

export const getFaceDetectorOptions = function() {
  return selectedFaceDetector === SSD_MOBILENETV1
    ? new faceapi.SsdMobilenetv1Options({ minConfidence })
    : new faceapi.TinyFaceDetectorOptions({ inputSize, scoreThreshold })
}

export const getCurrentFaceDetectionNet = function() {
  if (selectedFaceDetector === SSD_MOBILENETV1) {
    return faceapi.nets.ssdMobilenetv1
  }
  if (selectedFaceDetector === TINY_FACE_DETECTOR) {
    return faceapi.nets.tinyFaceDetector
  }
}

export const isFaceDetectionModelLoaded = function() {
  return !!getCurrentFaceDetectionNet().params
}

async function _changeFaceDetector(detector) {
  if (!isFaceDetectionModelLoaded()) {
    await getCurrentFaceDetectionNet().load(
      'https://resource.netclass.cn/weights'
    )
  }
}

export const changeFaceDetector = _changeFaceDetector
